var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Wine-Glass--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wine Glass Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 1.26A1.53 1.53 0 0 0 17.06 0H6.94a1.52 1.52 0 0 0 -1.49 1.3l-0.94 7.07a7.54 7.54 0 0 0 6.08 7.49 0.49 0.49 0 0 1 0.41 0.49v5.15a0.5 0.5 0 0 1 -0.5 0.5H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2h-1.5a0.5 0.5 0 0 1 -0.5 -0.5v-5.15a0.49 0.49 0 0 1 0.41 -0.49 7.49 7.49 0 0 0 6.08 -7.49ZM7.13 6a0.25 0.25 0 0 1 -0.19 -0.09 0.22 0.22 0 0 1 -0.06 -0.19l0.46 -3.5A0.26 0.26 0 0 1 7.59 2h8.82a0.26 0.26 0 0 1 0.25 0.22l0.46 3.5a0.25 0.25 0 0 1 -0.06 0.2 0.27 0.27 0 0 1 -0.19 0.08Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWine);
export default ForwardRef;